function getBackendAPIUrl(api_path) {
    return `${process.env.VUE_APP_API_HOST_NAME}/${api_path}`;
}

const httpUtility = {
    getBackendAPIUrl,
};
export default httpUtility;